import React from "react";
import styled from "styled-components";
import { Title } from "../../components/MiniComponents";

const PolicyRoot = styled.section`
    text-align: center;
    padding: 2em 0;
`;

const Link = styled.a`
    color: var(--main-color);
`;

const Policy = () => {
    return (
        <PolicyRoot id="policy">
            <Title>Règles de confidentialité</Title>
            <br />
            <div>
                The Darkest Tower Defense utilise le moteur de jeu Unity ainsi que Unity Ads qui collecte et partage des données utilisateurs.
                <br />
                <br />
                Pour voir leurs règles de confidentialité : <Link href="https://unity3d.com/legal/privacy-policy">General Unity Privacy Policy</Link> & <Link href="https://docs.unity.com/ads/GoogleDataSafety.html">Detailed Unity Ads Privacy Policy</Link>
                <br />
                <br />
                Pour demander la suppression de vos données, veuillez suivre les indications dans les liens précédents puisque Farlands Studio ne stocke aucunes données directement.
                <br />
                <br />
                Si vous avez des questions sur les règles de confidentialités, merci de contacter : farlands.indiegames@gmail.com.
            </div>
            <br />
            <br />
            <Title>Privacy Policy</Title>
            <br />
            <div>
                The Darkest Tower Defense uses the game engine Unity and Unity Ads that collects and shares user data.
                <br />
                <br />
                To see their privacy policy : <Link href="https://unity3d.com/legal/privacy-policy">General Unity Privacy Policy</Link> & <Link href="https://docs.unity.com/ads/GoogleDataSafety.html">Detailed Unity Ads Privacy Policy</Link>
                <br />
                <br />
                To request deletion of your data, please follow the instructions in the previous links as Farlands Studio does not store any data directly.
                <br />
                <br />
                If you have any questions about the privacy policy please contact : farlands.indiegames@gmail.com.
            </div>
        </PolicyRoot>
    )
};
export default Policy;



// WEBPACK FOOTER //
// ./src/pages/Policy/Policy.jsx